<template>
    <section ref="body" @click="$emit('focus')" v-touch:swipe="doSwipe">
        <div v-for="(part, ind) in sanitizedData" :key="`part-${ind}`">
            <div v-if="part.format === 'HTML'" v-html="part.data"/>
            <div v-else style="white-space:pre-line">{{part.data}}</div>
        </div>
    </section>
</template>

<script>
import DOMPurify from 'dompurify';
import axios from 'axios';

export default {
  name: 'messageBody',
  props: {
    data: Array,
    structure: Array,
    sender: String,
    allowImages: {
      type: Boolean,
      default: false
    },
    blockLinks: {
      type: Boolean,
      default: false
    },
    folderId: Number,
    message: Number
  },
  data: function() {
    return {
    };
  },
  watch: {
    data() {
    },
    allowImages(newVal) {
      this.processCIDImages();
    }
  },
  afterUpdate() {
    this.processCIDImages();
  },
  mounted() {
    this.processCIDImages();
  },
  methods: {
    doSwipe(evt) {
      console.log('body swipe', evt);
      this.$emit('swipe', evt);
    },
    processCIDImages() {
      if (this.areImagesAllowed) {
        this.$nextTick(() => {
          console.log('Process CID images');
          console.log(this.$refs);
          const images = this.$refs.body.getElementsByTagName('img');
          for (let i = 0; i < images.length; i++) {
            console.log('images', i, images[i]);
            console.dir(images[i]);
            if (images[i].dataset.vpop3cid) {
              const cid = `<${images[i].dataset.vpop3cid}>`;
              console.log('load CID', cid, this.structure);
              const thisImage = images[i];

              const part = this.structure.find(s => s.contentid === cid);
              axios
                .get(`/rest/user/folders/${this.folderId}/${this.message}/${part.section}`)
                .then(d => {
                  console.log('got part ' + part, d);
                  thisImage.src = d.data.data;
                });

              console.log(part);
            }
          }
        });
      }
    },
    getMessageHTML() {
      return this.$refs.body.innerHTML;
    }
  },
  computed: {
    areImagesAllowed() {
      if (this.folderId === -2) {
        return false;
      } else {
        return this.allowImages;
      }
    },
    areLinksAllowed() {
      if (this.folderId === -2) {
        return false;
      } else {
        return !this.blockLinks;
      }
    },
    sanitizedData() {
      let hooks = 0;
      let self = this;

      if (!this.areImagesAllowed) {
        DOMPurify.addHook('afterSanitizeAttributes', function(node) {
          if (('src' in node) && (node.src)) {
            console.log('found img', node.src);
            node.setAttribute('src', 'block_' + node.src);
            self.$emit('imagesBlocked');
          }
        });
        hooks++;
      } else {
        DOMPurify.addHook('afterSanitizeAttributes', function(node) {
          if (('src' in node) && (node.src)) {
            console.log('found img', node.src);
            if (node.src.substr(0, 4).toLowerCase() === 'cid:') {
              node.dataset.vpop3cid = node.src.substr(4);
              node.setAttribute('src', '');
            }
          }
        });
        hooks++;
      }

      if (!this.areLinksAllowed) {
        DOMPurify.addHook('afterSanitizeAttributes', function(node) {
          if (('href' in node) && (node.href)) {
            node.setAttribute('href', 'block_' + node.href);
          }
        });
        hooks++;
      }

      const sanitized = this.data.map(p => {
        if (p.format === 'HTML') {
          return { format: p.format,
            data: DOMPurify.sanitize(p.data, { FORCE_BODY: true, FORBID_TAGS: ['title'] })
          };
        } else {
          return p;
        }
      });
      while (hooks-- > 0) {
        DOMPurify.removeHook('afterSanitizeAttributes');
      }

      return sanitized;
    }
  }
};
</script>
